import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
// -- components --
import { FooterComponent } from 'app/components/footer/footer.component';
import { HeaderComponent } from 'app/components/header/header.component';
import { Jc3BannerComponent } from './components/jc3-banner/jc3-banner.component';
import { MainTabsComponent } from './components/main-tabs/main-tabs.component';
import { MobileJc3BannerComponent } from './components/mobile-jc3-banner/mobile-jc3-banner.component';
import { MobileMainTabsComponent } from './components/mobile-main-tabs/mobile-main-tabs.component';
// -- services --
import { TabNavigationService } from './services/tab-navigation.service';
import { FeedbackFormComponent } from './introduction/components/jc3-block-1/components/feedback-form/feedback-form.component';
import { MatDialog } from '@angular/material/dialog';
import { Jc3Service } from './jc3.service';

@Component({
    selector: 'app-jc3',
    standalone: true,
    imports: [
        // -- modules --
        TranslateModule,
        CommonModule,
        // -- components --
        Jc3BannerComponent,
        FooterComponent,
        HeaderComponent,
        MainTabsComponent,
        MobileJc3BannerComponent,
        MobileMainTabsComponent,
        FeedbackFormComponent,
    ],
    templateUrl: './jc3.component.html',
    styleUrl: './jc3.component.scss',
})
export class Jc3Component implements OnInit {
    selectedLanguage: any;
    banners: any = {};

    constructor(
        private dialog: MatDialog,
        private tabNavigationService: TabNavigationService,
        private _jc3Service: Jc3Service
    ) {}

    ngOnInit() {
        this.selectedLanguage = this.readLocalStorageValue('language');
        // Reset to default tab when component initializes
        this.tabNavigationService.resetToDefault();
        this.getBannerData();
    }

    getBannerData() {
        this._jc3Service.getBanner().subscribe({
            next: (res) => {
                if (res && res.length > 0) {
                    res?.at(0)?.mediaFileStores?.map((item: any) => {
                        this.banners = {
                            ...this.banners,
                            [item.jsonkey]: item.s3url,
                        };
                    });
                }
            },
            error: (error) => {
                console.error('Error fetching WhatsNew data:', error);
            },
        });
    }

    readLocalStorageValue(key: string) {
        let value = localStorage.getItem(key);
        return value;
    }

    switchedLanguage(data: any) {
        this.selectedLanguage = data;
    }

    openFeedbackPopup() {
        this.dialog.open(FeedbackFormComponent, {
            width: '95%',
            maxWidth: '750px',
            panelClass: 'custom-feedback-dialog',
            autoFocus: false,
            restoreFocus: false,
        });
    }
}
